<img [src]="imageRef.src" [width]="imageRef.width" [height]="imageRef.height" alt="" />
